import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Link2, Share2, Mail, MessageCircle, ExternalLink, Copy } from "lucide-react";
import { toast } from "sonner";

export const ShareTrackingDropdown = ({ url, code, product }) => {
  if (!url) return null;

  const subject = `Your WeLove whirlpool bath — tracking link`;
  const body =
    `Hello,\n\nYou can now track your WeLove whirlpool bath (${product || ""}) at any time using the link below.\n\n` +
    `${url}\n\nTracking code: ${code}\n\nIf you have any questions just reply to this email.\n\nThanks,\nThe WeLove team`;

  const wa = `https://wa.me/?text=${encodeURIComponent(`Hi — you can track your WeLove whirlpool bath here: ${url}`)}`;
  const mail = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Tracking link copied");
    } catch {
      toast.error("Couldn't copy — please copy manually");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: subject, text: `Track your WeLove whirlpool bath: ${product}`, url });
      } catch {
        /* user cancelled */
      }
    } else {
      copy();
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" className="border-zinc-200" data-testid="share-tracking-dropdown">
          <Share2 className="h-3.5 w-3.5 mr-1.5" /> Share with customer
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-zinc-500">
          Send tracking link
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={copy} data-testid="share-copy-link">
          <Copy className="h-3.5 w-3.5 mr-2" />
          Copy link
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={mail} data-testid="share-email">
            <Mail className="h-3.5 w-3.5 mr-2" />
            Email customer
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={wa} target="_blank" rel="noreferrer" data-testid="share-whatsapp">
            <MessageCircle className="h-3.5 w-3.5 mr-2" />
            Send via WhatsApp
          </a>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={nativeShare} data-testid="share-native">
          <Share2 className="h-3.5 w-3.5 mr-2" />
          More…
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={url} target="_blank" rel="noreferrer" data-testid="share-open">
            <ExternalLink className="h-3.5 w-3.5 mr-2" />
            Open as customer
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
